(function ($) {
    // Change the values of aria-hidden and aria-selected whenever a tab is clicked.
    $("#tripTabs li[role='tab']").click(function () {
        $("li[role='tab']").attr("aria-selected", "false"); // deselect all the tabs
        $(this).attr("aria-selected", "true"); // select this tab
        var tabpanid = $(this).attr("aria-controls"); // find out what tab panel this tab controls
        var tabpan = $("#" + tabpanid);
        $("div[role='tabpanel']").attr("aria-hidden", "true"); // hide all the panels
        tabpan.attr("aria-hidden", "false"); // show our panel
    });

    // Gives keyboard accessibility for tabs, so pressing enter when a tab has focus (key-code 13) is the same as clicking the tab with a mouse
    $("#tripTabs li[role='tab']").keydown(function (e) {
        if (e.which == 13) {
            $(this).click()
        }
    });

    var win = $(window),
        toggleServiceAdvisories = $('.toggle-service-advisories'),
        slideOut = $('.serviceAdvisories__container'),
        modalCover = $('.modalCover');

    toggleServiceAdvisories.on('click', function (e) {
        if (win.width() >= 992 && !slideOut.is(':visible')) {
            e.preventDefault();

            var me = $(this);

            slideOut.show(0, function () {
                $(this).css('right', 0);
            });

            modalCover.fadeIn(300);
            me.attr('aria-expanded', true);
            $('body').css('overflow', 'hidden');
            trap_focus(slideOut, 'searchAdvisories');
        }
    });

    $('.close-btn').on('click', function (e) {
        closeSlideOut();
    })

    win.debounceResize(function () {
        if (win.width() < 992) {
            closeSlideOut();
        }
    }).on('load', function () {
        alertBarControl();
    });

    function closeSlideOut() {
        if (slideOut.is(':visible')) {
            remove_trap_focus(slideOut, 'searchAdvisories');
            slideOut.css('right', -492).delay(300).hide(0);
            modalCover.fadeOut(300);
            $('body').css('overflow', '');
            toggleServiceAdvisories.attr('aria-expanded', false).trigger('focus');
        }
    }

    function alertBarControl() {
        var alertBars = $('.emergencyBarWrapper');

        alertBars.each(function () {
            var me = $(this),
                closeBtn = me.find('.closeBtn'),
                color = me.attr('id').replace('emergencyBarWrapper', '').toLowerCase(),
                hasClosed = sessionStorage.getItem(color + 'AlertBarClosed');

            if (hasClosed === null || hasClosed === undefined) {
                me.slideDown(600);

                closeBtn.on('click', function () {
                    me.slideUp(600);
                    sessionStorage.setItem(color + 'AlertBarClosed', true);
                })
            }
        })
    }

    $(window).on('load', function () {
        if ($("#uber").hasClass("interior")) {
            if (window.location.hash) {
                anchorOffset(window.location.hash.substring(1));
            }
        }
    });

    function anchorOffset(anchor) {
        // Offset scroll position of anchor link for sticky header
        var anchorIsEl = true;
        if (anchor.match("^#")) {
            anchor = anchor.replace("#", "");
        }

        if ($("[name=" + anchor + "]").parents('.AccordionTrigger').length) {
            $("[name=" + anchor + "]").closest('.AccordionTrigger').addClass('open');
            $("[name=" + anchor + "]").closest('.AccordionTrigger').next().slideDown("100");
        } else if ($("[name=" + anchor + "]").parents('.AccordionContent').length) {
            $('.AccordionContent:visible').slideUp("100");
            $('.AccordionTrigger').removeClass('open');
            $("[name=" + anchor + "]").parents('.AccordionContent').slideDown("100");
            $("[name=" + anchor + "]").parents('.AccordionContent').prev().addClass('open');
        }

        if (anchor != "") {
            if ($("[name=" + anchor + "]").length > 0) {
                anchor = $("[name=" + anchor + "]");
            } else if ($("#" + anchor).length > 0) {
                anchor = $("#" + anchor);
            } else {
                anchorIsEl = false;
            }
            if (anchorIsEl) {
                var offsetTop = anchor.offset().top;
                if ($(window).height() > 500) {
                    offsetTop = offsetTop - $("header").height();
                }
                $("html, body").animate({
                        scrollTop: offsetTop
                    },
                    1000
                );
            }
        }
    }

    $('#comm100-float-button-2 a[role="button"]').on('click', function (e) {
        e.preventDefault();
    });
})(jQuery);